import classNames from 'classnames'
import { FC, MouseEvent, PropsWithChildren } from 'react'

import styles from './DropdownList.module.scss'

export interface DropdownListProps {
  className?: string
  isScrollable?: boolean
  hasDivider?: boolean
  variant?: 'default' | 'compact'
  onMouseOver?: (event: MouseEvent<HTMLDivElement, globalThis.MouseEvent>) => void
}

export const DropdownList: FC<PropsWithChildren<DropdownListProps>> = (props) => {
  const {
    className,
    isScrollable = false,
    hasDivider = false,
    variant = 'default',
    children,
    onMouseOver,
  } = props

  return (
    <div
      className={classNames(styles.dropdownList, className, {
        [styles.scrollable]: isScrollable,
        [styles.divider]: hasDivider,
        [styles.compact]: variant === 'compact',
      })}
      onMouseOver={onMouseOver}
    >
      {children}
    </div>
  )
}
